import { render, staticRenderFns } from "./elall.vue?vue&type=template&id=857d2d2e&scoped=true&"
import script from "./elall.vue?vue&type=script&lang=js&"
export * from "./elall.vue?vue&type=script&lang=js&"
import style0 from "./elall.vue?vue&type=style&index=0&id=857d2d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857d2d2e",
  null
  
)

export default component.exports